"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _jsonTransformer = _interopRequireDefault(require("@lwc-utils/json-transformer"));

var Base = /*#__PURE__*/function () {
  function Base(data) {
    (0, _classCallCheck2.default)(this, Base);
    (0, _jsonTransformer.default)(data, this.template, this);
  }

  (0, _createClass2.default)(Base, [{
    key: "template",
    get: function get() {
      return {};
    }
  }]);
  return Base;
}();

exports.default = Base;
module.exports = exports.default;